import React, {PropTypes} from 'react';
import EntryContainer from './EntryContainer.jsx';
import VirtualEventContainer from './VirtualEventContainer.jsx';
import { formatCurrency } from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const TournamentEntry = ({
  id,
  name,
  collapsed,
  entries,
  virtualEvents,
  eventSummaries,
  onCollapseTournament,
  balanceDue
}) => 
{
  let eventSummariesText = '';
   
  eventSummaries.map((item) => 
    {
      if (eventSummariesText != '') eventSummariesText = `${eventSummariesText}, `; 
      eventSummariesText = `${eventSummariesText}${item.name} (${item.count})`; 
    });

  return (
  <div >
    <div style={{ display: 'flex' }}>
      <h3>
        <a onClick={() => onCollapseTournament(id)}>
          <i className={(collapsed ? "fa fa-expand" : "fa fa-compress")}
             style={{ marginRight: '14px' }} />
        </a>
          {`${name} - Balance Due: $${balanceDue.formatCurrency(2)}`}
      </h3>
      <div style={{ flex: '30%' }}>
        <p> 
          <p style={{ marginBottom: '0px', marginLeft: '10px' , marginTop: '29px' }}>{eventSummariesText}</p>
        </p>
      </div>
    </div>

    <div id="entries"
         className={collapsed ? "collapse" : "collapse in"}>
      <div className="list-group">
        {entries.map((item, index) => (
          <EntryContainer
            key={index}
            {...item}
          />
        ))}
      </div>
      <div className="list-group">
        {virtualEvents.map((item, index) => (
          <VirtualEventContainer
            key={index}
            {...item}
          />
        ))}
      </div>
    </div>
  </div>
);
};

TournamentEntry.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  collapsed: PropTypes.bool,
  onCollapseTournament: PropTypes.func,
  entries: PropTypes.arrayOf(PropTypes.object),
  virtualEvents: PropTypes.arrayOf(PropTypes.object),
  eventSummaries: PropTypes.arrayOf(PropTypes.object),
  balanceDue: PropTypes.number
};

TournamentEntry.defaultProps = {
  name: '',
  collapsed: false,
  entries: [],
  virtualEvents: [],
  eventSummaries: [],
  balanceDue: 0
};

export default TournamentEntry;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/TournamentEntry.jsx